import React from 'react';
import { ListElemText, roundInfoStore, RoundStatus, useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { globalTranslationKeys } from '../../../enums';

export const statusMapper = (result, roundId) => {
  if (result.status === RoundStatus.Upcoming) {
    return RoundStatus.Upcoming;
  }
  if (result.roundId === roundId && result.status === RoundStatus.Started) {
    return RoundStatus.Started;
  }
  return RoundStatus.Finished;
};

export const StatusRenderer = observer(({ result, status }) => {
  const t = useTranslation();

  if (result.roundId === roundInfoStore.roundId) {
    return (
      <ListElemText forSaving={true}>
        <span>&#9679;</span>
        <span>&#9679;</span>
        <span>&#9679;</span>
      </ListElemText>
    );
  } else if (result?.roundData) {
    const { previousPoint, resultPoint } = result?.roundData;
    return (
      <ListElemText>
        <span className='hasArrow'>
          <i className={`ui-lib-Triangle Triangle${previousPoint < resultPoint ? '-1' : previousPoint === resultPoint ? '-2' : ''}`} />
        </span>
        {resultPoint}
      </ListElemText>
    );
  } else {
    return (
      <ListElemText className='inner-lists-item-row-item-txt t-t-n' toCapitalize>
        {t(globalTranslationKeys.Soon)}
      </ListElemText>
    );
  }
});
